import { useAppSelector } from './useAppSelector'

export const useLanguages = () => useAppSelector((state) => state.languages)
